import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tools/heic-to-jpg/page.tsx");
